// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const uxie: PokeData = {
  "id": 480,
  "name": "uxie",
  "height": 3,
  "weight": 3,
  "base_experience": 261,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psybeam",
    "confusion",
    "psychic",
    "hypnosis",
    "swift",
    "amnesia",
    "rest",
    "tri-attack",
    "flail",
    "endure",
    "future-sight",
    "memento",
    "yawn",
    "imprison",
    "extrasensory",
    "calm-mind",
    "natural-gift",
    "double-hit",
    "mystical-power"
  ],
  "moves": [
    "psychic",
    "tri-attack",
    "future-sight",
    "calm-mind",
    "synchronize",
    "healing-wish",
    "prismatic-cage",
    "psychic-terrain",
    "psy-pulse",
    "psywave",
    "reflect",
    "kinesis",
    "psy-ball"
  ],
  "evolution_chain": {
    "id": 241,
    "item": null,
    "species": [
      {
        "name": "uxie",
        "order": 481,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 150,
    "speed": 139,
    "ability_power": 110
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
